module.exports = __webpack_public_path__ + "static/img/sec4-cont-txt02@m.42c6420.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-history/sec4-cont-txt02@m.png
// module id = i+6Z
// module chunks = 0